import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  SecurityInfo,
  API_PATH_SECURITY_INFOS,
} from './securityInfo.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getSecurityInfos(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<SecurityInfo>> {
  return http.get(`${API_PATH_SECURITY_INFOS}/${deliveryFunctionId}`);
}

export function createSecurityInfo(
  deliveryFunctionId: string,
  body: WithAuditDetails<SecurityInfo>,
): AxiosPromise<ServerResponse<SecurityInfo>> {
  return http.post(`${API_PATH_SECURITY_INFOS}/${deliveryFunctionId}`, body);
}
